import { UseSurveyTimerProps } from './shared-survey-progress-ring.types';

export function useSurveyTimer({
  totalTimeInSeconds,
  progress,
}: UseSurveyTimerProps) {
  const elapsedSeconds = Math.min(
    Math.floor(progress * totalTimeInSeconds),
    totalTimeInSeconds
  );

  const remainingSeconds = Math.max(totalTimeInSeconds - elapsedSeconds, 0);

  const remainingMinutes = (() => {
    if (remainingSeconds < 60 && remainingSeconds >= 30) return 1;
    if (remainingSeconds > 0) return Math.ceil(remainingSeconds / 60);
    return 0;
  })();

  return {
    remainingMinutes,
  };
}
